const personalisationToVariantMap = [
  {
    criteria: ['has_custom_wrapping'],
    variantNames: ['Emballage personnalisé']
  },
  {
    criteria: ['has_engraving'],
    variantNames: ['Gravure']
  },
  {
    criteria: ['has_soap_engraving'],
    variantNames: ['Gravure sur savon']
  },
  {
    criteria: ['has_custom_wrapping', 'has_engraving'],
    variantNames: [
      'Emballage personnalisé + Gravure',
      'Gravure + Emballage personnalisé'
    ]
  },
  {
    criteria: ['has_custom_wrapping', 'has_soap_engraving'],
    variantNames: [
      'Emballage personnalisé + Gravure sur savon',
      'Gravure sur savon + Emballage personnalisé'
    ]
  }
]
// BELOW, CHECK THE VARIANTS THAT COST AND THEN PLACE DO AN IF ELSE BASED ON IF THEY COST OR NOT

/**
 * Given a personalisation name, sets the customisation variant
 * selector to the correct customisation variant
 *
 * @param personalisation The Shopify name of the personalisation variant (eg: 'Gravure sur savon')
 */
function setCustomisationSelector(personalisation) {
  if (personalisation != 'Aucun') {
    let values = [personalisation]
    const selectors = [...document.querySelectorAll('variant-radios.customisation input[name="Personnalisation"]')];
    const currentPersonalisation = selectors.find(selector => selector.checked);
    let customisationSelector = currentPersonalisation;
    if(selectors.length > 1) {
      // If another personalisation is selected already, include that
      if (currentPersonalisation.value != 'Aucun' && !currentPersonalisation.value.includes(personalisation)) {
        values = [
          `${currentPersonalisation.value} + ${personalisation}`,
          `${personalisation} + ${currentPersonalisation.value}`
        ]
      }
      // Check the radio button for the customisation variant we need
      customisationSelector = selectors.find(selector =>
        values.some(value => selector.value.includes(value))
      );
    }
    if(customisationSelector) {
      customisationSelector.click();
    }
  }
}

/**
 * Disable a personalisation
 *
 * @param personalisation The Shopify name of the personalisation variant (eg: 'Gravure sur savon')
 */
function unsetCustomisationSelector(personalisation) {
  const selectors = [...document.querySelectorAll('input[name="Customisation"')]
  const currentPersonalisation = selectors.find(selector => selector.checked)
  selectors.forEach(selector => (selector.checked = false))
  if (currentPersonalisation.value.includes('+')) {
    // Multiple personalisation are active. Find the one without this personalisation
    const newOptionName = currentPersonalisation.value
      .replace(` + ${personalisation}`, '')
      .replace(`${personalisation} + `, '')
    selectors.find(selector => selector.value === newOptionName).checked = true
  } else {
    selectors.find(selector => selector.value === 'Aucun').checked = true
  }
}

/**
 * Product Engraving - This houses the functions for replacing the text in box
 * within the modal so that we can add them as line item properties.
 */
class productEngraving extends HTMLElement {
  constructor() {
    super()
    this.inputField = this.querySelector('.input-field');
    this.inputEmbossingField = this.querySelector('.input-embossing-field');
    this.inputCalligraphyField = this.querySelector('.input-calligraphy-field');
    this.inputMonogram = this.querySelector('.input-monogram');
    this.imageChangeButtons = this.querySelectorAll('.change-img-btn');
    this.monogramImage = this.querySelector('.monogram-image');
    this.insertHeartBtn = this.querySelector('.insert-heart');

    if (this.inputEmbossingField) {
      this.inputEmbossingField.addEventListener('keyup', e =>
        this.replaceText(e, false, 'embossing')
      )
      this.inputEmbossingField.addEventListener('change', e => {
        if (e.target.value.length > 3) { 
          e.target.value = e.target.value.slice(0, 3);
          e.target.maxLength = 3;
          e.target.closest('.accordion-block').setAttribute('data-value',`${window.personalisation_locale.initials}: ${this.inputEmbossingField.value}`);
          e.target.nextElementSibling.innerHTML = `${e.target.maxLength}/${e.target.maxLength}`
        }
      })
    } else if (this.inputCalligraphyField) {
      this.inputCalligraphyField.addEventListener('keyup', e => {
        this.replaceText(e, false, 'calligraphy')
        if (e.target.value.length <= 15) {
          e.target.value = e.target.value.slice(0, 15);
          e.target.maxLength = 15;
          e.target.closest('.accordion-block').setAttribute('data-value',`${window.personalisation_locale.initials}: ${this.inputCalligraphyField.value}`);
          e.target.nextElementSibling.innerHTML = `${e.target.maxLength}/${e.target.maxLength}`
        }
      })
    } else if (this.inputMonogram) {
      this.inputMonogram.addEventListener('change', e => {
        if (e.target.value.length > 2) { 
          e.target.value = e.target.value.slice(0, 2);
          e.target.maxLength = 2;
          e.target.closest('.accordion-block').setAttribute('data-value',`${window.personalisation_locale.initials}: ${this.inputMonogram.value}`);
          e.target.nextElementSibling.innerHTML = `${e.target.maxLength}/${e.target.maxLength}`
        }
      })
    } else if (this.inputCalligraphyField) {
      this.inputCalligraphyField.addEventListener('keyup', e =>
        this.replaceText(e, false, 'calligraphy')
      )
    } else if (this.inputField) {
      this.inputField.addEventListener('keyup', e => this.replaceText(e, true))
      this.inputField.addEventListener('paste', e => e.preventDefault())
    }

    if (this.inputMonogram) {
      this.inputMonogram.addEventListener('keyup', e => this.replaceMonogram(e))
    }
    if (this.insertHeartBtn) {
      this.insertHeartBtn.addEventListener('click', e => this.insertHeart(e))
    }
  }
  
  insertHeart(e) {
    if (this.inputEmbossingField.value.length >= 3) return
    this.inputEmbossingField.value = this.inputEmbossingField.value + '♡';
    e.currentTarget.closest('.accordion-block').classList.add('completed');
    e.currentTarget.closest('.accordion-block').setAttribute('data-value',`${window.personalisation_locale.initials}: ${this.inputEmbossingField.value}`);
    e.currentTarget.closest('product-engraving').querySelector('button')?.removeAttribute('disabled');
    e.currentTarget.closest('personalisation-modal').querySelector('.product-form__submit').removeAttribute('disabled');
  }

  replaceText(e, isSlider, type) {
    if(e.currentTarget.classList.contains('regex-check')) {
      let inputNumberRegexCheck = e.currentTarget.classList.contains('regex-check-numbers-allowed');
      if(inputNumberRegexCheck){
        const regex = /^[a-zA-Z0-9& ]*$/;
        regexContentChecker(regex);
      } else {
        const regex = /^[a-zA-Z& ]*$/;
        regexContentChecker(regex);
      }

      function regexContentChecker(regex) {
        let value = e.currentTarget.value
        const heart = /♡/ig;
        const heartText = /HEART/ig;
        if((value).includes('♡')) {
          value = value.replace(heart,'HEART').toUpperCase();
        }
        const isLegal = regex.test( value );
        if(!isLegal && e.which !== 32) {
          e.currentTarget.value = e.currentTarget.value.slice(0, (e.currentTarget.value.length - 1));
        } else {
          value = value.replace(heartText,'♡').toUpperCase();
        }
      }
    }
    if (isSlider == true) {
      const slides = e.currentTarget.closest('product-engraving').querySelectorAll('.swiper-slide');
      const value = e.target.value.length == 0 ? 'ABC' : e.target.value;
      let font = '';

      const maxLength = e.target.maxLength
      const length = e.target.value.length
      e.target.closest('div').querySelector('.soap-letter-count').innerHTML = `${length}/${maxLength}`

 
  
      for (const slide of slides) {
        if (value.length < 4) {
          slide.querySelector('.font-box').innerHTML = `<p>${value.toUpperCase()}</p>`
        }

        if (slide.classList.contains('active') == true) {
          let activeSlide = slide.querySelector('.slide-box')
          font = `${window.personalisation_locale.typography}: ${activeSlide.getAttribute('data-val')}`
          slide.parentElement
            .closest('.personalisation-modal-grid')
            .classList.add('soap-engraving-active')
          slide.parentElement
            .closest('.personalisation-modal-grid')
            .querySelector('.soap_image')
            .setAttribute('data-content', value.toUpperCase())
          slide.parentElement
            .closest('.accordion-block')
            .setAttribute('data-value', `${font}, ${window.personalisation_locale.initials}: ${value.toUpperCase()}`)
        }
      }
    }
    
    if (type == 'embossing') {
      e.currentTarget.closest('.accordion-block').setAttribute('data-value',`${window.personalisation_locale.initials}: ${e.currentTarget.value.toUpperCase()}`);
      if(e.currentTarget.classList.contains('input-embossing-field')) {
        if(e.currentTarget.value.length > 0 && e.currentTarget.value.trim() != "") {
          e.currentTarget.closest('.accordion-block').classList.add('completed');
          e.currentTarget.closest('product-engraving').querySelector('button')?.removeAttribute('disabled');
          e.currentTarget.closest('personalisation-modal').querySelector('.product-form__submit').removeAttribute('disabled');
        } else {
          e.currentTarget.closest('.accordion-block').classList.remove('completed');
          e.currentTarget.closest('product-engraving').querySelector('button')?.setAttribute('disabled','disabled');
          e.currentTarget.closest('personalisation-modal').querySelector('.product-form__submit').setAttribute('disabled','disabled')
        }
      }
    }

    if (type == 'calligraphy') {
      if(e.currentTarget.classList.contains('input-calligraphy-field')) {
        if(e.currentTarget.value.length > 0 && e.currentTarget.value.trim() != "") {

          let calligraphyType = '';

          Array.from(this.imageChangeButtons).forEach(button => {
            if (button.classList.contains('active')) {
              calligraphyType = button.innerHTML
            }
          })    

          e.currentTarget.closest('.accordion-block').classList.add('completed');
          e.currentTarget.closest('product-engraving').querySelector('button')?.removeAttribute('disabled');
          e.currentTarget.closest('personalisation-modal').querySelector('.product-form__submit').removeAttribute('disabled');
          e.currentTarget.closest('.accordion-block').setAttribute('data-value',`${window.personalisation_locale.name}: ${e.currentTarget.value.toUpperCase()}`)
        } else {
          e.currentTarget.closest('.accordion-block').classList.remove('completed');
          e.currentTarget.closest('product-engraving').querySelector('button')?.setAttribute('disabled','disabled');
          e.currentTarget.closest('personalisation-modal').querySelector('.product-form__submit').setAttribute('disabled','disabled')
          e.currentTarget.closest('.accordion-block').removeAttribute('data-value',`${window.personalisation_locale.name}: ${e.currentTarget.value.toUpperCase()}`)
        }
      }

    }
  }

  replaceMonogram(e) {
    const value = e.currentTarget.value.toUpperCase()
    const sortedValue = value.split('').sort().join('');

    // TO DO - THIS NEEDS TO BE CHANGE TO A LIVE HOSTING SERVICE
    if (value.length < 2) return

    this.monogramImage.setAttribute(
      'src',
      `https://cdn.shopify.com/s/files/1/0569/5602/7079/files/${sortedValue}.svg`
    )
    e.target
      .closest('.personalisation-modal')
      .querySelector(
        '.monogram-styles'
      ).innerHTML = `<style>.soap_image.monogram:before { background-image: url('http://cdn.shopify.com/s/files/1/0569/5602/7079/files/${value}.svg') }</style>`
    e.target
      .closest('.accordion-block')
      .setAttribute('data-value', `Monogram: ${value.toUpperCase()}`)
  }
}

/**
 * Gift Wrapping - Grabs the selected options and add's them as the values on the
 * accordion block
 */
class giftWrapping extends HTMLElement {
  constructor() {
    super()
    this.giftWrapSelects = this.querySelectorAll('.gift-wrap-select')
    this.giftWrapInput = this.querySelector('.input-field');
    this.submitButton = this.querySelector('button');
    this.inputField = this.querySelector('.input-field');

    if (this.inputField) {
      this.inputField.addEventListener('keyup', e => this.replaceText(e))
      this.inputField.addEventListener('paste', e => e.preventDefault())
    }

    if (this.giftWrapSelects) {
      this.giftWrapSelects.forEach(select => {
        if(select.options.length > 1) {
          select.addEventListener('change', e => this.fetchSelectData(e))
        } else {
          select.closest('.accordion-block').setAttribute('data-value', 'Suprise Me');
        }
      })
    }

    this.submitButton.disabled = true;
  }

  replaceText(e) {
    let combinedData = `${window.personalisation_locale.initials}: ${e.currentTarget.value.toUpperCase()}`; // Set initials to always uppercase
    let inputNumberRegexCheck = e.currentTarget.classList.contains('regex-check-numbers-allowed');

    const inputKey = e.which;

    // Change input value to uppercase
    e.target.value.toUpperCase();

    if(inputNumberRegexCheck){
      const keyStartAllowFrom = 49; // When numbers are allowed.
      regexKeysChecker(keyStartAllowFrom);
    } else {
      const keyStartAllowFrom = 65; // When numbers not allowed.
      regexKeysChecker(keyStartAllowFrom)
    }

    function regexKeysChecker(keyStartAllowFrom) {
      if (
        !(inputKey >= keyStartAllowFrom && inputKey <= 120) &&
        inputKey != 16 &&
        inputKey != 189 &&
        inputKey != 0
        ) {
        if(inputKey !== 32) {
          if (e.target.value.length == 1) {
            e.target.value = ''
          } else {
            e.target.value = e.target.value.slice(
              0,
              e.target.value.length - 1
            )
          }
        }
      }
    }

    this.giftWrapSelects.forEach(select => {
      const label = select.getAttribute('data-label')
      const text = select.options[select.selectedIndex].text;
      combinedData = combinedData + `, ${label}: ${text}`
    });
    if (e.currentTarget.value == '') {
      this.submitButton.disabled = true;
    } else {
      this.submitButton.disabled = false;
    }
    e.currentTarget.closest('.accordion-block').setAttribute('data-value',combinedData);
  }

  checkButtonState() {
    let allCompleted = true;
    this.giftWrapSelects.forEach(select => {
      if(select.classList.contains('selected') == false) {
        allCompleted = false
      }
    });

    if(!allCompleted) return;
    this.submitButton.removeAttribute('disabled');
  }

  fetchSelectData(e) {
    e.target.classList.add('selected');
    this.checkButtonState();
    let combinedData = `${window.personalisation_locale.initials}: ${this.querySelector('.input-field').value}`
    this.giftWrapSelects.forEach(select => {
      const label = select.getAttribute('data-label')
      const text = select.options[select.selectedIndex].text;
      combinedData = combinedData + `, ${label}: ${text}`
    })
    e.target.closest('.accordion-block').setAttribute('data-value', combinedData);
  }
}

/**
 * Gift Wrapping - Grabs the selected options and add's them as the values on the
 * accordion block
 */
class telegramMessaging extends HTMLElement {
  constructor() {
    super()
    this.letterCount = this.querySelector('.telegram-letter-count')
    this.textarea = this.querySelector('.textarea-telegram-field')
    this.submitButton = this.querySelector('.accordion-submit')

    this.textarea.addEventListener('keyup', e => this.messageCheck(e))
    this.submitButton.addEventListener('click', e => this.variantCheck(e))
  }

  messageCheck(e) {
    if(this.textarea.value.length > 0) {
      this.textarea.closest('.accordion-block').classList.add('completed');
    } else {
      this.textarea.closest('.accordion-block').classList.remove('completed');
    }
    let noSpaceValue = this.textarea.value.replace(/ /g, '').length
    Array.from(window.personalisation.telegramVariants).forEach(item => {
      if (item.title == noSpaceValue) {
        e.currentTarget
          .closest('.accordion-block')
          .setAttribute('data-id', item.id)
        return
      }
    })
    this.letterCount.innerText = `${noSpaceValue}/100`
    if (noSpaceValue <= 100) {
      e.currentTarget
        .closest('.accordion-block')
        .setAttribute('data-value', this.textarea.value)
    } else {
      this.textarea.value = this.textarea.value.slice(0, -1)
    }
  }

  findVariant(variantArray, value) {
    for (var i = 0; i < variantArray.length; i++) {
      if (variantArray[i].title === value) {
        return variantArray[i].id
      }
    }
  }

  variantCheck(e) {
    const variantArray = window.personalisation.telegramVariants
    const value = this.querySelector('.textarea-telegram-field').value.length
    const variantID = this.findVariant(variantArray, value)
    e.target.closest('.accordion-block').setAttribute('telegram-variant', variantID)
  }
}

/**
 * Personalisation Form - This extracts the data values from the accordion blocks and
 * will add them as line item properties.
 */
class personalisationForm extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector('form')
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    }
    this.cartItems = document.querySelector('cart-items')
    this.miniCart = document.getElementById('mini-cart')
  }

  vanillaSerialize(data) {
    let obj = {}
    for (let [key, value] of data) {
      if (obj[key] !== undefined) {
        if (!Array.isArray(obj[key])) {
          obj[key] = [obj[key]]
        }
        obj[key].push(value)
      } else {
        obj[key] = value
      }
    }
    return obj
  }

  onSubmitHandler(evt) {
    evt.preventDefault()
    let propArray = []
    let telegramVariant = ''
    const submitButton = this.querySelector('[type="submit"]')

    let accordionBlocks = document.getElementsByClassName('completed')
    for (let i = 0; i < accordionBlocks.length; i++) {
      let accordionBlock = accordionBlocks[i]
      let label = accordionBlock.dataset.label;
      let value = accordionBlock.dataset.value;
      if (label == null || value == null) return
      if (accordionBlock.getAttribute('data-id')) {
        telegramVariant = accordionBlock.getAttribute('data-id')
      }
      propArray.push({
        key: `${label}`,
        value: `${value}`
      })
    }

    const jObject = propArray.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: item.value }),
      {}
    )

    submitButton.setAttribute('disabled', true)
    submitButton.classList.add('loading')

    // NEW OBJ
    let itemsArr = []

    const prodID = this.form.querySelector('input[name="id"]').value;

    if (telegramVariant.length > 0) {
      itemsArr.push({
        id: telegramVariant,
        quantity: 1,
        properties: jObject
      })
    } else {
      if (!propArray) {
        itemsArr.push({
          id: prodID,
          quantity: 1
        })
      } else {
        itemsArr.push({
          id: prodID,
          quantity: 1,
          properties: jObject
        })
      }
    }
    const body = JSON.stringify({
      items: itemsArr,
      sections: this.cartItems.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(parsedState => {
        if (parsedState.status == 422) {
          document
            .querySelector('.mini-cart-add-error')
            .classList.remove('hidden')
          this.miniCart?.open()
        } else {
          document.getElementById('personalisation-modal-container').classList.remove('visible');
          document.querySelector('.mini-cart-add-error').classList.add('hidden')
          this.cartItems.renderContents(parsedState);
          return this.cartItems.checkGifts()
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading')
        submitButton.removeAttribute('disabled')
        if(this.querySelector('input[value="Aucun"]')) {
          this.querySelector('input[value="Aucun"]').click();
        }
      })
  }
}

/**
 * Personalisation Modal - Includes the following
 * - Slider Initlization
 * - Close Modal
 * - Slide Input Count
 */
class personalisationModal extends HTMLElement {
  constructor() {
    super()
    this.blockButtons = this.querySelectorAll('.block-button');
    this.personalisationModal = document.getElementById(
      'personalisation-modal-container'
    )

    if (this.blockButtons) {
      this.blockButtons.forEach(button => {
        button.addEventListener('click', e => this.changeBlocks(e))
      })
    }

    // Form Submission
    this.accordionBlocks = this.querySelectorAll('.accordion-block')
    this.closeButton = this.querySelector('.button--close-modal')
    this.addButton = this.querySelectorAll('.accordion-submit')
    this.imageChangeButtons = this.querySelectorAll('.change-img-btn')
    this.modalSlides = this.querySelectorAll('.modal-slide')
    this.modalImage = this.querySelector('.personalisation-modal__image img')
    // Global
    this.inputFields = this.querySelectorAll('.input-field')
    this.inputMonograms = this.querySelectorAll('.input-monogram')
    this.fontExclusions = this.querySelector('#font-exclusions')
    this.details = this.querySelectorAll('details .accordion__title')
    // Box Illustrations
    this.boxIllustrationSlider = this.querySelector('.box-illustration-slider')
    this.boxIllustrationCount = this.querySelector('.box-illustration-count')
    // Soap Engravings
    this.soapEngravingSlider = this.querySelector('.soap-font-slider')
    this.soapEngravingCount = this.querySelector(
      '.soap-font-illustration-count'
    )
    this.inputEngraving = document.getElementById('input-engraving-initials');
    this.inputInitials = document.getElementById('input-initials');
    this.inputGiftwrap = document.getElementById('input-giftwrap');
    this.inputCalligraphy = document.getElementById('input-calligraphy-field');
    // Engravings
    this.engravingSlider = this.querySelector('.engraving-slider')
    this.engravingCount = this.querySelector('.engraving-illustration-count')

    // Close Modal
    this.closeButton.addEventListener('click', e => this.closeModal(e))

    //check for inspector tampering
    if (this.inputEngraving != null) {
      this.inputEngraving.addEventListener('change', e => {
        const maxCharLimit = e.target.getAttribute('data-m-c');
        if (e.target.value.length > maxCharLimit) { 
          e.target.value = e.target.value.slice(0, maxCharLimit);
          e.target.maxLength = maxCharLimit;
          e.target.closest('.accordion-block').setAttribute('data-value',`${window.personalisation_locale.initials}: ${this.inputEngraving.value}`);
          e.target.nextElementSibling.innerHTML = `${e.target.maxLength}/${e.target.maxLength}`
        }
      })
    }
    if (this.inputInitials != null) {
      this.inputInitials.addEventListener('change', e => {
        if (e.target.value.length > 3) { 
          e.target.value = e.target.value.slice(0, 3);
          e.target.maxLength = 3;
          e.target.closest('.accordion-block').setAttribute('data-value',`${window.personalisation_locale.initials}: ${this.inputInitials.value}`);
          e.target.nextElementSibling.innerHTML = `${e.target.maxLength}/${e.target.maxLength}`
        }
      })
    }
    if (this.inputGiftwrap != null) {
      this.inputGiftwrap.addEventListener('change', e => {
        if (e.target.value.length > 3) { 
          e.target.value = e.target.value.slice(0, 3);
          e.target.maxLength = 3;
          e.target.closest('.accordion-block').setAttribute('data-value',`${window.personalisation_locale.initials}: ${this.inputGiftwrap.value}`);
          e.target.nextElementSibling.innerHTML = `${e.target.maxLength}/${e.target.maxLength}`
        }
      })
    }
    if (this.inputCalligraphy != null) {
      this.inputCalligraphy.addEventListener('change', e => {
        if (e.target.value.length > 15) { 
          e.target.value = e.target.value.slice(0, 15);
          e.target.maxLength = 15;
          e.target.closest('.accordion-block').setAttribute('data-value',`${window.personalisation_locale.initials}: ${this.inputCalligraphy.value}`);
          e.target.nextElementSibling.innerHTML = `${e.target.maxLength}/${e.target.maxLength}`
        }
      })
    }
    
    // Add To Cart Button which add's a tick and injects line item prop onto el
    this.addButton.forEach(button => {
      button.addEventListener('click', e => this.completeSection(e))
    })

    this.imageChangeButtons.forEach(button => {
      button.addEventListener('click', e => this.changeModalImage(e))
    })

    this.details.forEach(details => {
      details.addEventListener('click', e => this.checkDetails(e))
    })

    // Input Checker for Counter
    this.inputFields.forEach(input =>
      input.addEventListener('keyup', e => this.inputCheck(e))
    )
    
    this.inputFields.forEach(input =>
      input.addEventListener('keyup', e => this.completeSection(e, true))
    )
    
    this.inputMonograms.forEach(input =>
      input.addEventListener('keyup', e => this.completeSection(e, true))
    )

    // Change Active Slide
    this.modalSlides.forEach(modalSlide =>
      modalSlide.on('click', e => this.changeActive(e))
    )

    // Slider Initilization
    this.soapEngravingSwiper = this.initSliders(
      this.soapEngravingSlider,
      window.personalisation.soapEngravingFontOptions,
      this.soapEngravingCount,
      true
    )

    this.engravingSwiper = this.initSliders(
      this.engravingSlider,
      window.personalisation.engravingFontOptions,
      this.engravingCount,
      true
    )

    this.boxIllustrationSwiper = this.initSliders(
      this.boxIllustrationSlider,
      window.personalisation.boxArtOptions,
      this.boxIllustrationCount,
      false
    )

    // Inject Options
    this.injectEl('#paper-reference', window.personalisation.custom_wrapping)
    this.injectEl('#ribbon-colour', window.personalisation.gift_wrap_ribbons)

    // Reset on load
    if(this.querySelector('input[value="Aucun"]')) {
      this.querySelector('input[value="Aucun"]').click();
    }
  }

  changeBlocks(e) {
    const type = e.currentTarget.getAttribute('name');
    for (const button of this.blockButtons) {
      const name = button.getAttribute('name')
      const container = document.querySelector(`.${name}-container`)
      if (type == name) {
        button.classList.add('active')
        container.classList.add('active')
        if (name == 'monogram') {
          e.target.closest('.personalisation-modal').querySelector('.soap_image').classList.add('monogram');
        } else {
          e.target.closest('.personalisation-modal').querySelector('.soap_image').classList.remove('monogram');
        }
      } else {
        button.classList.remove('active')
        container.classList.remove('active')
      }
    }
  }

  checkDetails(e) {
    let isSoap = e.currentTarget.getAttribute('data-id')
    if (!isSoap) return
    e.currentTarget
      .closest('.personalisation-modal')
      .classList.toggle('soap-engraving-active')
  }

  // Fetch and Return the labels and the selected values in the modal
  fetchPersonlisationData(e) {
    let lineItemProp = ''
    this.accordionBlocks.forEach(accordionBlock => {
      let label = accordionBlock.getAttribute('data-label')
      let value = accordionBlock.getAttribute('data-value')
      if (label == null || value == null) return
      lineItemProp = lineItemProp + `"${label}": "${value}"`
    })
    return lineItemProp
  }

  // Close Function for the Modal
  closeModal() {
    this.personalisationModal.classList.remove('visible')
  }

  // Remove and apply the active class on slide click.
  changeActive(e) {
    let slideVal = e.currentTarget
      .querySelector('.slide-box')
      .getAttribute('data-val')
    let valClass = slideVal.toLowerCase().replace(/ /g, '-')
    let accordion = e.target.closest('.accordion-block')
    let modalSlides = accordion.querySelectorAll('.modal-slide')
    modalSlides.forEach(modalSlide => modalSlide.classList.remove('active'))
    accordion.setAttribute( 'data-value', `${window.personalisation_locale.typography}:${slideVal}, ${window.personalisation_locale.initials}: ${e.target.closest('.accordion-block').querySelector('.input-field').value.toUpperCase()}`)
    e.target.closest('.modal-slide').classList.add('active')
    e.currentTarget
      .closest('.personalisation-modal')
      .setAttribute('engraving-font', valClass)
  }

  changeModalImage(e) {
    Array.from(this.imageChangeButtons).forEach(button => {
      button.classList.remove('active')
    })
    e.currentTarget.classList.add('active')
    this.modalImage.setAttribute(
      'src',
      e.currentTarget.getAttribute('data-img')
    )
  }

  // Injects Dynamic Data
  injectEl(elID, metafield) {
    let el = this.personalisationModal.querySelector(elID)
    if(!el) return;
    Array.from(metafield).forEach(item => {
      let option = document.createElement('option');
      if(option.index == 1) {
        option.setAttribute('selected');
      }
      option.setAttribute('value', item.name);
      option.innerHTML = item.name
      el.appendChild(option)
    })
  }

  // Updates the count with the current input length
  inputCheck(e) {
    const target = e.target
    const maxLength = target.maxLength
    const length = target.value.length
    target
      .closest('div')
      .querySelector('.soap-letter-count').innerHTML = `${length}/${maxLength}`
    return
  }

  // Adds a tick to the section to mark its complete
  completeSection(e, initalsInput) {
    const parentEl = e.target.closest('.accordion-block');
    const errorMessage = parentEl.querySelector('.error-message');
    let inputFieldValue = parentEl.querySelector('.regex-check') ? parentEl.querySelector('.regex-check').value : parentEl.querySelector('.input-field').value;
    const regex = /^[a-zA-Z0-9& ]*$/;
    const heart = /♡/ig;
    const heartText = /HEART/ig;
    const hyphen = /-/ig;
    const hyphenText = /HYPHEN/ig;
    if((inputFieldValue).includes('♡')) {
      inputFieldValue = inputFieldValue.replace(heart,'HEART')
    }
    if((inputFieldValue).includes('-')) {
      inputFieldValue = inputFieldValue.replace(hyphen,'HYPHEN')
    }
    const isLegal = regex.test( inputFieldValue );
    if(!isLegal) {
      errorMessage.classList.add('active');
      e.preventDefault();
      return;
    } else {
      inputFieldValue = inputFieldValue.replace(heartText,'♡')
      inputFieldValue = inputFieldValue.replace(hyphenText,'-')
      errorMessage.classList.remove('active');
      const modalContent = e.target.closest('.personalisation-modal__content');
      const type = parentEl.getAttribute('data-type');
      if(type.length > 0) {
        setCustomisationSelector(type)
      }
      parentEl.querySelector('.accordion__title p span').innerText = parentEl.querySelector('.accordion__title p span').innerText.replace('ADD', 'Added');
      // checks if field is initials input or monograming and prevents accordion closing on each key press
      if(initalsInput != true) {
        parentEl.querySelector('details').removeAttribute('open');
      }
      parentEl.classList.add('completed')
      modalContent .querySelector('.product-form__submit').removeAttribute('disabled')
      modalContent.querySelector('button span').innerHTML = window.cart_locale.add_to_cart;
    }
  }

  initSliders(sliderEl, array, countEl, isFont) {
    let defaultBoxArt = ''
    if (isFont == false) {
      defaultBoxArt = document
        .querySelector('personalisation-modal')
        .getAttribute('default-boxart')
    }
    if (sliderEl) {
      for (const item of array) {
        let wrapper = document.createElement('div')
        let inner = document.createElement('div')
        // IF THIS CERTAIN SLIDER HAS EXCLUSIONS DO NOT DO
        if (isFont) {
          inner.innerHTML = '<p>ABC</p>'
          inner.setAttribute(
            'class',
            `slide-box font-box font-box--${item.name
              .toLowerCase()
              .replace(/ /g, '-')}`
          )
        } else {
          let img = document.createElement('img')
          img.setAttribute('src', item.path)
          img.setAttribute('alt', item.name)
          inner.setAttribute('class', `slide-box art-box`)
          inner.appendChild(img)
        }
        inner.setAttribute('data-val', item.name)
        wrapper.setAttribute('class', 'modal-slide swiper-slide')
        wrapper.appendChild(inner)

        if (item.name == 'Officine') {
          wrapper.classList.add('class', `active`)
        }
        if (isFont == false) {
          if (defaultBoxArt == item.handle) {
            wrapper.querySelector('div').classList.add('active')
            sliderEl.querySelector('.swiper-wrapper').prepend(wrapper)
          } else {
            sliderEl.querySelector('.swiper-wrapper').appendChild(wrapper)
          }
        } else {
          sliderEl.querySelector('.swiper-wrapper').appendChild(wrapper)
        }
      }

      countEl.innerHTML = `${array.length} Options`

      const modalSlides = this.querySelectorAll('.modal-slide')
      if (isFont) {
        modalSlides.forEach(modalSlide =>
          modalSlide.addEventListener('click', e => this.changeActive(e))
        )
      } else {
        modalSlides.forEach(modalSlide =>
          modalSlide.addEventListener('click', e => this.changeActiveBox(e))
        )
      }

      // Init Box Illustrations Slider
      return new Swiper(sliderEl, {
        watchSlidesProgress: true,
        loop: false,
        spaceBetween: 15,
        breakpoints: {
          1: {
            slidesPerView: 2.8
          },
          440: {
            slidesPerView: 4
          },
          750: {
            slidesPerView: 2.8
          },
          920: {
            slidesPerView: 3.7
          }
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        }
      })
    }
  }

  changeActiveBox(e) {
    let allBoxes = e.target
      .closest('.accordion-block')
      .querySelectorAll('.art-box')
    allBoxes.forEach(box => box.classList.remove('active'))
    e.target.closest('.slide-box').classList.add('active')
    e.target
      .closest('.accordion-block')
      .setAttribute('data-value', e.target.alt)
  }

  // Fetches the Modal via AJAX with Liquid controlling what elements show
  fetchProductData(productHandle,variantID) {
    fetch(`${productHandle}?sections=buly_modal&variant=${variantID}`)
      .then(response => response.json())
      .then(parsedState => {
        this.renderContents(parsedState);
        return parsedState
      })
      .catch(err => {
        console.error(err)
      })
  }

  // Gather the sections we are wishing to render
  getSectionsToRender() {
    // Note: MAX 5 sections (or AJAX API requests will fail)
    const sections = [
      {
        id: 'personalisation-modal-container',
        section: 'modal',
        selector: '.personalisation-modal__inner'
      }
    ]
    return sections
  }

  // Render the new element that's been requested
  renderContents(parsedState) {
    this.getSectionsToRender().forEach(section => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id)

      if (!elementToReplace) {
        return
      }

      const newContent = parsedState.buly_modal
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        newContent,
        section.selector
      )
    })
  }

  // OS2
  getSectionInnerHTML(html, selector = '.shopify-section', hideClass) {
    let newEl = new DOMParser().parseFromString(html, 'text/html')
    newEl = newEl.querySelector(selector) || newEl
    if (hideClass) {
      newEl
        .querySelectorAll(hideClass)
        .forEach(el => el.classList.add('hide-to-animate'))
    }
    return newEl.innerHTML
  }
}

customElements.define('product-engraving', productEngraving)
customElements.define('personalisation-form', personalisationForm)
customElements.define('personalisation-modal', personalisationModal)
customElements.define('gift-wrapping', giftWrapping)
customElements.define('telegram-messaging', telegramMessaging)
